// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 416 ? "e7373332" : chunkId) + "." + {"416":"a62973d2473ea0c1","926":"0c233c24c9317452","930":"401f01c7ea0b1a3e"}[chunkId] + ".js";
};